import * as React from 'react';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import SaleHeader from '~/apps/pos/mobile/components/sales/SaleHeader';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import Support from '~/apps/shared/components/settings/Support';
import { steps } from '~/apps/pos/mobile/containers/sales/CreateSale';

const SaleStepHelp = (props) => {
  const { actionKey, onBack } = props;

  const helpName = (stepKey) => {
    let name;
    switch (stepKey) {
      case steps.BAD_MAIN:
      case steps.BAD_PAYMENT:
        name = 'BAD REQUEST';
        break;
      case steps.RESULT:
        name = 'RESULT';
        break;
      case steps.ADDITIONAL_FIELD:
        name = 'ADDITIONAL FIELD';
        break;
      case steps.PAID_TYPE:
        name = 'PAID TYPE';
        break;
      case steps.PRODUCTS:
        name = 'PRODUCTS';
        break;
      case steps.RELAY_CODE:
        name = 'RELAY CODE';
        break;
      case steps.REMOTE_CHEKOUT:
        name = 'REMOTE CHECKOUT';
        break;
      default:
        name = 'HELP';
        break;
    }
    return name;
  };

  const onBackToCurrentPage = () => {
    if (onBack) onBack(actionKey);
  };

  return (
    <PageMobileWrapper className="m__cont--fh">
      <SaleHeader
        onBack={onBackToCurrentPage}
        title="Support"
      />

      <BodyWrapper>
        {/* {helpName(actionKey)} */}
        <div className="m__body__titl">Need assistance?</div>
        <Support className="sett--m"/>
      </BodyWrapper>
    </PageMobileWrapper>
  );
};

export default SaleStepHelp;
